import { Empty, Input, Table, Tag, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { gatewayCRUD } from "../../../../actions/gateway";
import { char, number } from "../../../../utils";
import moment from "moment";

export const StudentClearance = (props) => {
  const { dataId, index } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        gatewayCRUD
          .loadCustomerClearance(dataId)
          .then((resp) => {
            setData(resp.data?.results);
          })
          .catch(() => {
            setData([]);
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId, index]);

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <span>{text ? moment(text).format("DD MMM YYYY") : "N/A"}</span>
      ),
    },
    {
      title: "Control Number",
      dataIndex: "logs__control_number",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <span className="ellipsis-cell">{text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Refference",
      dataIndex: "reference",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <Tooltip title={char.toUpperCase(text)}>
          <span className="ellipsis-cell">{char.toUpperCase(text)}</span>
        </Tooltip>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 120,
      align: "right",
      render: (text) => <span>{number.fNumberDoublePoint(text)}</span>,
    },
    {
      title: "Status",
      dataIndex: "is_approved",
      align: "center",
      width: 50,
      render: (approved) => (
        <Tag color={approved ? "green" : "orange"}>
          {approved ? "Approved" : "Pending"}
        </Tag>
      ),
    },
  ];

  const filteredData = data?.filter((item) => {
    if (!filter) return true;

    return String(item.logs__control_number)
      .toLowerCase()
      .includes(String(filter).toLowerCase());
  });

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-4">
          <div className="col-md-2 col-sm-6">
            <Input
              placeholder="Search by control number..."
              allowClear
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <Table
              columns={columns}
              dataSource={filteredData}
              size="small"
              rowKey="trxid"
              bordered
              pagination={false}
              loading={loading} // ✅ built-in loading spinner
              scroll={{
                x: 900,
                y: "60vh",
              }}
              locale={{
                emptyText: <Empty description="No data available" />,
              }}
              className="custom-payment-table"
            />
          </div>
        </div>
      </div>
    </>
  );
};
